import { render, staticRenderFns } from "./MannequinDiagramBack.vue?vue&type=template&id=6ba3a10e"
import script from "./MannequinDiagramBack.vue?vue&type=script&lang=js"
export * from "./MannequinDiagramBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports